export enum FormTypes {
    YEARLY,
    MONTHLY,
    ONETIME,
    QUARTERLY
  }  